import { useState, useEffect } from "react";
import mobileIcon from "../../../assets/svg/DetailsChannel/mobileIcon.svg";
import tabletIcon from "../../../assets/svg/DetailsChannel/tabletIcon.svg";
import tvIcon from "../../../assets/svg/DetailsChannel/TvIcon.svg";
import laptopIcon from "../../../assets/svg/DetailsChannel/webIcon.svg";
import { defaultFiles } from "../../../dummyjson/channelDefaultValues";
import FilesDragAndDrop from "../../FileUploader/file-uploader";
import "./FileUploaderContainer.scss";

function FileUploaderContainer(props) {
  const [uploadedFiles, setUploadedFiles] = useState(
    props.files ? props.files : defaultFiles
  );
  const [deviceList, setDeviceList] = useState([
    {
      deviceName: "Mobile",
      iconPath: mobileIcon,
      isActive: true,
      deviceId: 3,
    },
    {
      deviceName: "Tablet",
      iconPath: tabletIcon,
      isActive: false,
      deviceId: 4,
    },
    {
      deviceName: "TV",
      iconPath: tvIcon,
      isActive: false,
      deviceId: 1,
    },
    {
      deviceName: "Web",
      iconPath: laptopIcon,
      isActive: false,
      deviceId: 2,
    },
  ]);
  useEffect(() => {
    if (props.files) {
      setUploadedFiles(props.files);
    } else if (props.isNewChannel) {
      setUploadedFiles(defaultFiles);
    }
  }, [props.files, props.isNewChannel]);

  const handleTabClick = (deviceId) => {
    const tabData = deviceList.map((item) => {
      if (item.deviceId === deviceId) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    setDeviceList(tabData);
  };

  const onChangeHandler = (event) => {
    const currentFiles = { ...uploadedFiles };
    currentFiles[event.type][event.subType] = {
      file: event.file,
      multiPart: event.multiPart,
      type: event.type,
      subType: event.subType,
    };
    setUploadedFiles(currentFiles);
    props.onChange(currentFiles);
  };

  return (
    <div className="file-uploader-container">
      <div className="file-uploader-device-list">
        <ul>
          {deviceList.map((device) => {
            return (
              <li
                key={device.deviceId}
                className={device.isActive ? "active" : ""}
                onClick={() => {
                  handleTabClick(device.deviceId);
                }}
              >
                <img src={device.iconPath} alt="icon" />
                <span>{device.deviceName}</span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="file-uploader-body">
        {deviceList[2].isActive ? (
          <div className="tv">
            <FilesDragAndDrop
              id="tv-thumb"
              label={"TV Logo"}
              size={"1:1"}
              type={"TV"}
              subType={"thumbnail"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["TV"]["thumbnail"]}
            />
            <FilesDragAndDrop
              id="tv-poster"
              label={"TV Hero Art"}
              size={"2:3"}
              type={"TV"}
              subType={"poster"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["TV"]["poster"]}
            />
            <FilesDragAndDrop
              id="tv-cover"
              label={"TV Cover Art"}
              size={"16:9"}
              type={"TV"}
              subType={"coverart"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["TV"]["coverart"]}
            />
          </div>
        ) : null}

        {deviceList[3].isActive ? (
          <div className="web">
            <FilesDragAndDrop
              id="web-thumb"
              label={"Web Logo"}
              size={"1:1"}
              type={"Web"}
              subType={"thumbnail"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Web"]["thumbnail"]}
            />
            <FilesDragAndDrop
              id="web-poster"
              label={"Web Hero Art"}
              size={"2:3"}
              type={"Web"}
              subType={"poster"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Web"]["poster"]}
            />
            <FilesDragAndDrop
              id="web-cover"
              label={"Web Cover Art"}
              size={"16:9"}
              type={"Web"}
              subType={"coverart"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Web"]["coverart"]}
            />
          </div>
        ) : null}

        {deviceList[0].isActive ? (
          <div className="mobile">
            <FilesDragAndDrop
              id="mobile-thumb"
              label={"Mobile Logo"}
              size={"1:1"}
              type={"Mobile"}
              subType={"thumbnail"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Mobile"]["thumbnail"]}
            />
            <FilesDragAndDrop
              id="mobile-poster"
              label={"Mobile Hero Art"}
              size={"2:3"}
              type={"Mobile"}
              subType={"poster"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Mobile"]["poster"]}
            />
            <FilesDragAndDrop
              id="mobile-cover"
              label={"Mobile Cover Art"}
              size={"16:9"}
              type={"Mobile"}
              subType={"coverart"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Mobile"]["coverart"]}
            />
          </div>
        ) : null}

        {deviceList[1].isActive ? (
          <div className="tablet">
            <FilesDragAndDrop
              id="tablet-thumb"
              label={"Tablet Logo"}
              size={"1:1"}
              type={"Tablet"}
              subType={"thumbnail"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Tablet"]["thumbnail"]}
            />
            <FilesDragAndDrop
              id="tablet-poster"
              label={"Tablet Hero Art"}
              size={"2:3"}
              type={"Tablet"}
              subType={"poster"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Tablet"]["poster"]}
            />
            <FilesDragAndDrop
              id="tablet-cover"
              label={"Tablet Cover Art"}
              size={"16:9"}
              type={"Tablet"}
              subType={"coverart"}
              onChange={(event) => onChangeHandler(event)}
              readOnly={false}
              file={uploadedFiles["Tablet"]["coverart"]}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

FileUploaderContainer.defaultProps = {
  onUpload: () => {},
  onChange: () => {},
  isNewChannel: false, // Add default
};

export default FileUploaderContainer;
